const faqItems = document.querySelectorAll('.custom-faq__item');

faqItems.forEach(item => {
  const button = item.querySelector('.custom-faq__question');
  const answerWrapper = item.querySelector('.custom-faq__answer-wrapper');
  const answer = item.querySelector('.custom-faq__answer');

  if (item.classList.contains('is-open')) {
    answerWrapper.style.height = answer.offsetHeight + 'px';
  }

  button.addEventListener('click', function() {
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      answerWrapper.style.height = answer.offsetHeight + 'px';
      requestAnimationFrame(() => {
        answerWrapper.style.height = '0px';
      });
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    } else {
      const targetHeight = answer.offsetHeight;
      answerWrapper.style.height = '0px';
      requestAnimationFrame(() => {
        answerWrapper.style.height = targetHeight + 'px';
      });
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    }
  });

  answerWrapper.addEventListener('transitionend', function() {
    if (item.classList.contains('is-open')) {
      answerWrapper.style.height = 'auto';
    }
  });
});
